module.exports = __webpack_public_path__ + "static/media/funnel-s.21ac87e0.svg";